import React from 'react'
import { Layout, Row, Col, Card, Statistic, Button } from 'antd'
import { FileTextOutlined, ToolOutlined, BarChartOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import type { RootState } from '@store/index'

const { Content } = Layout

export const Dashboard: React.FC = () => {
  const navigate = useNavigate()
  const materialRequests = useSelector((state: RootState) => state.materials.materialRequests.items || [])
  const operations = useSelector((state: RootState) => state.operations.dailyReports.items || [])

  const pendingMaterialRequests = materialRequests.filter((r) => r.status === 'pending').length
  const pendingOperations = operations.filter((o) => o.status === 'draft').length

  return (
    <Content className="dashboard-content">
      <div style={{ padding: '24px' }}>
        <h1>Dashboard</h1>
        <p>Sistema de Gestión de Operaciones y Activos - Phase 1</p>

        <Row gutter={[16, 16]} style={{ marginTop: '32px' }}>
          <Col xs={24} sm={12} lg={8}>
            <Card hoverable onClick={() => navigate('/material-requests')}>
              <Row align="middle" justify="space-between">
                <Col>
                  <Statistic
                    title="Material Requests"
                    value={materialRequests.length}
                    suffix={`(${pendingMaterialRequests} pending)`}
                  />
                </Col>
                <Col>
                  <FileTextOutlined style={{ fontSize: '32px', color: '#1890ff' }} />
                </Col>
              </Row>
              <Button type="primary" block style={{ marginTop: '16px' }}>
                View Material Requests
              </Button>
            </Card>
          </Col>

          <Col xs={24} sm={12} lg={8}>
            <Card hoverable onClick={() => navigate('/operations')}>
              <Row align="middle" justify="space-between">
                <Col>
                  <Statistic
                    title="Operations"
                    value={operations.length}
                    suffix={`(${pendingOperations} drafts)`}
                  />
                </Col>
                <Col>
                  <ToolOutlined style={{ fontSize: '32px', color: '#52c41a' }} />
                </Col>
              </Row>
              <Button type="primary" block style={{ marginTop: '16px' }}>
                View Operations
              </Button>
            </Card>
          </Col>

          <Col xs={24} sm={12} lg={8}>
            <Card hoverable onClick={() => navigate('/analytics')}>
              <Row align="middle" justify="space-between">
                <Col>
                  <Statistic title="Analytics" value="Real-time" />
                </Col>
                <Col>
                  <BarChartOutlined style={{ fontSize: '32px', color: '#faad14' }} />
                </Col>
              </Row>
              <Button type="primary" block style={{ marginTop: '16px' }}>
                View Analytics
              </Button>
            </Card>
          </Col>
        </Row>

        <Card style={{ marginTop: '24px' }}>
          <h2>Phase 1 Features</h2>
          <ul>
            <li>✅ Material Request Workflow Management</li>
            <li>✅ Operations Daily Reports & Activity Tracking</li>
            <li>✅ Real-time Analytics & KPI Dashboards</li>
            <li>✅ Tool & Equipment Certification Tracking</li>
            <li>✅ Personnel Performance Metrics</li>
            <li>✅ Tool Utilization Analytics</li>
            <li>✅ 71 Integration Tests - All Passing</li>
            <li>✅ Offline Support Ready</li>
          </ul>
        </Card>
      </div>
    </Content>
  )
}

export default Dashboard
